var _style, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _polygon2, _path14, _defs3, _defs4, _path15, _path16, _path17, _path18, _path19, _path20, _defs5, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs6, _path52, _path53, _path54, _path55, _defs7, _defs8, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _polygon3, _polygon4, _polygon5, _path67, _path68, _path69, _path70, _path71;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMadale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_2_);}\r\n\t.st3{clip-path:url(#SVGID_4_);fill:#F2F2F2;}\r\n\t.st4{clip-path:url(#SVGID_4_);fill:#FF7900;}\r\n\t.st5{clip-path:url(#SVGID_4_);fill:#F99012;}\r\n\t.st6{clip-path:url(#SVGID_4_);fill:#FFA932;}\r\n\t.st7{clip-path:url(#SVGID_4_);fill:#E56700;}\r\n\t.st8{clip-path:url(#SVGID_4_);fill:#183962;}\r\n\t.st9{clip-path:url(#SVGID_6_);}\r\n\t.st10{clip-path:url(#SVGID_8_);fill:#F2F2F2;}\r\n\t.st11{clip-path:url(#SVGID_10_);fill:#EBC18A;}\r\n\t.st12{clip-path:url(#SVGID_10_);fill:#E5B379;}\r\n\t.st13{clip-path:url(#SVGID_10_);fill:#5F4002;}\r\n\t.st14{clip-path:url(#SVGID_10_);fill:#442D00;}\r\n\t.st15{clip-path:url(#SVGID_10_);fill:#FFE81D;}\r\n\t.st16{clip-path:url(#SVGID_10_);fill:#FFD800;}\r\n\t.st17{clip-path:url(#SVGID_10_);fill:#A5CE39;}\r\n\t.st18{clip-path:url(#SVGID_10_);fill:#96C000;}\r\n\t.st19{clip-path:url(#SVGID_10_);fill:#FF554C;}\r\n\t.st20{clip-path:url(#SVGID_10_);fill:#F73E30;}\r\n\t.st21{clip-path:url(#SVGID_10_);fill:#FDE3C7;}\r\n\t.st22{clip-path:url(#SVGID_12_);fill:#FFE700;}\r\n\t.st23{clip-path:url(#SVGID_12_);fill:#FFD300;}\r\n\t.st24{clip-path:url(#SVGID_12_);fill:#915100;}\r\n\t.st25{clip-path:url(#SVGID_14_);}\r\n\t.st26{clip-path:url(#SVGID_16_);fill:#F2F2F2;}\r\n\t.st27{clip-path:url(#SVGID_16_);fill:#214470;}\r\n\t.st28{clip-path:url(#SVGID_16_);fill:#183962;}\r\n\t.st29{clip-path:url(#SVGID_16_);fill:#FEE619;}\r\n\t.st30{clip-path:url(#SVGID_16_);fill:#FED206;}\r\n\t.st31{clip-path:url(#SVGID_16_);fill:#FFA932;}\r\n\t.st32{clip-path:url(#SVGID_16_);fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_83_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.5,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 1.5,
    y: 0,
    width: 147.4,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.6,72.8c0,37.4,30.3,67.6,67.6,67.6s67.6-30.3,67.6-67.6c0-37.4-30.3-67.6-67.6-67.6S7.6,35.5,7.6,72.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.1,130h19.2c1.9,0,3.5-1.6,3.5-3.5v0c0-1.9-1.6-3.5-3.5-3.5h-19.2c-1.9,0-3.5,1.6-3.5,3.5v0 C104.6,128.5,106.2,130,108.1,130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.7,130h7.5c1.9,0,3.5-1.6,3.5-3.5v0c0-1.9-1.6-3.5-3.5-3.5h-7.5c-1.9,0-3.5,1.6-3.5,3.5v0 C133.3,128.5,134.8,130,136.7,130"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.5,95.9c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7 C144.6,98.6,143.5,97.4,143.5,95.9 M144.5,95.9c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6 C145.2,94.3,144.5,95.1,144.5,95.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28,138.4c0-2.3,1.9-4.1,4.1-4.1c2.3,0,4.1,1.9,4.1,4.1c0,2.3-1.9,4.1-4.1,4.1C29.9,142.5,28,140.6,28,138.4  M29.7,138.4c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5C30.8,135.9,29.7,137,29.7,138.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.9,119.4H23.1c-3.1,0-5.5,2.5-5.5,5.5v0c0,3.1,2.5,5.5,5.5,5.5h21.9c3.1,0,5.5-2.5,5.5-5.5v0 C50.5,121.9,48,119.4,44.9,119.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.3,144.3c-3.7-1.6-3.3-1.2-5-5c-1.6,3.7-1.2,3.3-5,5c3.7,1.6,3.3,1.2,5,5 C124,145.6,123.6,146,127.3,144.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.9,102.9c-2.4-1-2.1-0.8-3.2-3.2c-1,2.4-0.8,2.1-3.2,3.2c2.4,1,2.1,0.8,3.2,3.2 C5.8,103.7,5.5,103.9,7.9,102.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.4,106.3h-7.5c-1.9,0-3.5,1.6-3.5,3.5v0c0,1.9,1.6,3.5,3.5,3.5h7.5c1.9,0,3.5-1.6,3.5-3.5v0 C26.8,107.9,25.3,106.3,23.4,106.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.1,124.9c0,3,2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5c0-3-2.5-5.5-5.5-5.5S3.1,121.9,3.1,124.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.7,114.1c0.2,0.2,0.2,0.5,0.1,0.7c-0.1,0.2-0.3,0.4-0.6,0.4H99.5L81.3,51.9h42.3c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.1,0.5l-5.7,31.2c0,0.2,0,0.4,0.1,0.5L141.7,114.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115,102H74.5L56.3,38.7h40.1c0.3,0,0.5,0.2,0.6,0.5L115,102z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.8,90H44.3c-0.3,0-0.5-0.2-0.6-0.5l-17.8-62c-0.1-0.2,0-0.4,0.1-0.6c0.1-0.2,0.3-0.3,0.5-0.3h42.6 c0.3,0,0.5,0.2,0.6,0.5L87.8,90z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "71.1,90 74.5,102 87.8,90  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "95.7,102 99.5,115.2 115,102  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M27.3,23.2c1.1-1,1.8-2.4,1.8-4c0-3-2.4-5.4-5.4-5.4c-3,0-5.4,2.4-5.4,5.4c0,2.6,1.8,4.8,4.3,5.3l33.6,116.6 c0.1,0.3,0.2,0.5,0.3,0.7c0,0,0,0,0,0c0.7,1,2,1.3,3,0.8c1.1-0.5,1.6-1.7,1.3-2.9L27.3,23.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_84_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 1.5,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 1.5,
    y: 0,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M144.1,45h-19.5c-3.2-0.1-5.7-2.7-5.7-5.9c0-3.3,2.7-5.9,5.9-5.9h8.6c3.4,0,6.2-2.8,6.2-6.2 c0-3.4-2.8-6.2-6.2-6.2h-14.8C107.8,11.8,94.3,6.2,79.6,5.3v0c-0.3,0-0.6,0-0.9,0c-0.1,0-0.3,0-0.4,0c-1.3-0.1-2.5-0.1-3.8-0.1 C37.1,5.1,6.8,35.4,6.8,72.8c0,12,3.1,23.2,8.6,33h-0.7c-3.1,0-5.6,2.5-5.6,5.6c0,3.1,2.5,5.6,5.6,5.6h17.1c1.7,0,3,1.4,3,3 c0,1.7-1.4,3-3,3h-8c-1.9,0-3.5,1.5-3.5,3.5c0,1.9,1.5,3.5,3.5,3.5h14.5c9.4,6,20.3,9.7,32.1,10.4v0c1.7,0.1,3.3,0.2,5,0.2 c37.4,0,67.7-30.3,67.7-67.7c0-6.3-0.9-12.4-2.5-18.1h3.5c2.7,0,4.9-2.2,4.9-4.9C148.9,47.2,146.7,45,144.1,45"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M12.9,123.1H7.6c-1.9,0-3.5,1.5-3.5,3.5s1.5,3.5,3.5,3.5h5.2c1.9,0,3.5-1.5,3.5-3.5S14.8,123.1,12.9,123.1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M144.1,110.2c-2.6,0-4.8-2.1-4.8-4.8c0-2.6,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8 C148.9,108,146.7,110.2,144.1,110.2 M144.1,101.7c-2,0-3.7,1.7-3.7,3.7c0,2.1,1.7,3.7,3.7,3.7c2.1,0,3.7-1.7,3.7-3.7 C147.8,103.3,146.1,101.7,144.1,101.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4.2,98.6c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7C6.8,97.4,5.6,98.6,4.2,98.6  M4.2,94.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C5.7,95.1,5,94.3,4.2,94.3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M23.1,144.3c3.7-1.6,3.3-1.2,5-5c1.6,3.7,1.2,3.3,5,5c-3.7,1.6-3.3,1.2-5,5C26.5,145.6,26.9,146,23.1,144.3 "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M126,131.6c2.4-1,2.1-0.8,3.2-3.2c1,2.4,0.8,2.1,3.2,3.2c-2.4,1-2.1,0.8-3.2,3.2 C128.1,132.4,128.3,132.6,126,131.6"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 21.1,
    y: 35.7,
    width: 79.6,
    height: 66.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M90.5,102.5H31.3c-3.7,0-6.7-3-6.7-6.7v-3.9c0-1.2,1-2.2,2.2-2.2h68.1c1.2,0,2.2,1,2.2,2.2v3.9 C97.2,99.5,94.2,102.5,90.5,102.5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M90.4,102.5H31.2c-3.7,0-6.7-3-6.7-6.7v-3.9c0-1.2,1-2.2,2.2-2.2h68.1c1.2,0,2.2,1,2.2,2.2v3.9 C97.1,99.5,94.1,102.5,90.4,102.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M40.9,99.3h55.2c-1.2,1.9-3.3,3.2-5.7,3.2H31.2c-3.7,0-6.7-3-6.7-6.7v-3.9c0-1.2,1-2.2,2.2-2.2h2.7v6.4 c0,0,0,3.1,3.4,3.1C36.3,99.2,40.9,99.3,40.9,99.3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.1,90.7H31.7c-2.9,0-5.2-2.3-5.2-5.2v-4.6c0-2.9,2.3-5.2,5.2-5.2h58.4c2.9,0,5.2,2.3,5.2,5.2v4.6 C95.3,88.4,93,90.7,90.1,90.7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M34.3,75.7h-2.6c-2.9,0-5.2,2.3-5.2,5.2v4.6c0,2.9,2.3,5.2,5.2,5.2h2.6C34.3,90.7,28.9,84.4,34.3,75.7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M92.2,88.2c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9 C91.8,87.3,92.2,87.7,92.2,88.2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M93.1,86.1c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6C92.8,85.5,93.1,85.8,93.1,86.1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M31,74.4c0,0-5.1,2.8-5.5,5.2c-0.4,2.4,1,4.3,2.8,3.7c1.8-0.6,1.2-1.5,2.1-2.7c0.9-1.2,4.8-5.1,5.4-2.5 c0.6,2.5,2.2,3.1,3.4,2.5c1.2-0.6,1.3-1.8,3.3-1.3c1.9,0.4,4.6-0.1,5.2,1.2c0.6,1.3,0.3,2.7,2.3,2.4c2.1-0.3,1.5-4.5,2.6-4 c1.6,0.6-0.2,5.7-0.2,6.5c0,2.4,4,2.8,4.2,0.1c0.1-1.6-0.4-7.6,2-7.3c2.4,0.3,2.5-2.1,4.3-1c1.8,1,5.2,3.3,5.6,5.2 c0.3,1.3-1.2,6.4,3.7,5.9c3.3-0.3-0.8-9.7,0.8-10.1c2.6-0.7,1.8,3.2,2.1,4.2c0.3,1.2,2.5,2.1,5.2-0.6c2.7-2.7,7.9-4.2,8.5-3 c0.6,1.2,2.4,0,3.7-0.3c1.3-0.3,1.6,3.4,2.8,3.6c1.2,0.1,1.2-0.3,1.2-0.9c0-0.6-0.3-6.5-3.9-6.5c-2.7,0-13.1-3.3-13.1-3.3 L48.8,71C48.8,71,35.4,69.8,31,74.4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M50,83c-1.9,0.4-1.7-1.2-2.3-2.5c-0.2-0.5-0.9-0.5-1.5-0.9c-0.1,0,1.5-1.2,2.2-0.5c0.7,0.7,0.6,1.4,0.7,1.9 c0.1,0.4,0.9,1.5,1.9,1.3C51,82.2,50.7,82.9,50,83"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M36.3,76.5c-0.9-0.3-1.5,0.8-1.5,0.8c0.5,0,0.8,0.2,1,0.8c0.6,2.5,2.2,3.1,3.4,2.5c0,0-1.4-0.7-1.7-1.9 C37.2,77.5,37.2,76.8,36.3,76.5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M31,74.4c0,0-5.1,2.8-5.5,5.2c-0.4,2.4,1,4.3,2.8,3.7C28.3,83.3,24.2,79.9,31,74.4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M69.9,79.6c0.4,0.7,1,3,0.7,4.9c-0.3,1.9,1.5,3.9,1.5,3.9c-4.9,0.4-3.4-4.6-3.7-5.9 c-0.4-1.9-3.8-4.2-5.6-5.2C62.8,77.2,68.4,76.9,69.9,79.6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M95.2,79.3c-0.8-3.2-2.6-4.6-2.6-4.6c3.6,0,3.9,5.9,3.9,6.5s0,1-1.2,0.9C95.2,82.1,95.7,81.8,95.2,79.3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M76.7,81.2c-0.2-0.6,0.1-3.3-1.2-3.7c-1.3-0.4-2.6,0.7-2.6,0.7c2.6-0.7,1.8,3.2,2.1,4.2 c0.3,1.2,2.5,2.1,5.2-0.6C80.2,81.8,77.3,82.7,76.7,81.2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M92,67.7c4.4-1,7.1,0.3,5.3,1.5c-1.8,1.2,1.5,1.8,3.1,4.8c1.6,3-5.4,2.1-8.3,2.2c-3,0.1-2.8,1.6-5.4,3.4 c-2.5,1.8-8-2.5-11.1-3.4c-3.1-0.9-9.2,4.5-12.3,5.8c-3.1,1.3-6.7-3.4-8.3-5.8c-1.6-2.4-6.8,3-10.3,6.1c-3.4,3.1-5.1-2.8-5.8-4.5 c-0.7-1.6-4.8-0.9-7.7,0.3c-3,1.2-4.4,0.1-5-1.5c-0.6-1.6-2.5,1.1-4.2-0.1c-2.6-2.1,0.9-4,2.1-4.9c0.4-0.3,0.4-0.7,0.4-1.2 c0-0.6,0.1-1.1,0.6-1.5c0.9-0.8,2.2-1.2,3.4-1.2c1.5-0.1,2.9-0.3,4.4-0.4c6.3-0.4,12.6,0.3,18.9-0.7c0.3,0,0.6-0.1,0.9-0.2 c3.6-0.9,4.5-1.2,6.7-0.6C61.6,66.4,89.4,68.3,92,67.7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M98.1,73.9c-0.7,1.1-6.1,0.6-7.7,0.6c-1.6,0-3.6,2.8-5.2,3.6c-1.6,0.7-5.4-1.8-7.3-2.2 c-1.9-0.4-3.4,0.2-3.4,0.2c0.4,0,0.7,0,1.1,0.1c3.1,0.9,8.6,5.2,11.1,3.4c2.5-1.8,2.4-3.3,5.4-3.4c3-0.1,10,0.7,8.3-2.2 c-1.6-3-4.9-3.6-3.1-4.8c0,0-1.7,0.3-1.6,1.2C95.9,71.3,98.6,73.2,98.1,73.9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M57.2,76.3c-0.4-0.4-0.9-0.8-1.6-0.9c-0.7-0.1-1.4-0.1-2,0.1c0.6-0.1,1,0.1,1.3,0.6 c1.6,2.4,5.2,7.1,8.3,5.8c0.9-0.4,1.9-1,3.1-1.8c-0.3,0.2-0.8,0.2-1.1,0.2c-1.4,0.2-2.8,0.1-4.1-0.6 C59.7,78.9,58.5,77.5,57.2,76.3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M41.2,77.7c-0.3-0.8-0.8-1.7-1.6-2.2c-0.8-0.5-1.8-0.5-2.7-0.5c-1.7,0.2-3.2,0.9-4.5,2 c-0.4,0.3-0.8,0.7-1.2,1.1c1.4-0.5,3-1,4.4-1.2c1.6-0.2,3,0,3.4,0.9c0.7,1.6,2.4,7.6,5.8,4.5C44.7,82.3,43.3,82.9,41.2,77.7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M56.8,65.5c0,0-18,5.3-24.8,5.3c0,0-3.4,0.1-4.3,0c-0.9-0.1-0.4,0.3,0,0.4c2.5,0.8,5.4,0.6,7.9,0.5 c3.1-0.2,6.2-0.8,9.2-1.7c3.3-1,6.6-1.9,9.7-3.3C55.3,66.4,56.1,66.1,56.8,65.5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M56.9,65.8c-1.6,1.5-3.2,2.9-4.9,4.4c-1,0.9-2.1,1.9-3.2,2.7C47.9,73.6,46,74,46,75.3 c0.4,0.6,6.4-3.2,9-5.3c1.2-1,2.4-2.3,2.3-3.9c0-0.2-0.1-0.4-0.2-0.3C57,65.7,57,65.7,56.9,65.8C56.9,65.8,56.9,65.8,56.9,65.8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M58,65.7c0,0,14,5.8,24.8,5.3c0,0,10.1-0.3,11-0.4c0.9-0.1,0.4,0.3,0,0.4c-2.5,0.8-12.1,1.1-14.6,0.9 c-3.1-0.2-6.2-0.8-9.2-1.7c-3.3-1-6.6-1.9-9.7-3.3C59.5,66.6,58.7,66.2,58,65.7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M57.9,66c1.6,1.5,3.2,2.9,4.9,4.4c1,0.9,2.1,1.9,3.2,2.7c0.8,0.6,2.8,1.1,2.8,2.4c-0.4,0.6-6.4-3.2-9-5.3 c-1.2-1-2.4-2.3-2.3-3.9c0-0.2,0.1-0.4,0.2-0.3C57.8,65.8,57.8,65.9,57.9,66C57.9,65.9,57.9,66,57.9,66"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M89.8,72.9H32c-1.6,0-3-1.3-3-3v-3.6c0-1.6,1.3-3,3-3h57.8c1.6,0,3,1.3,3,3v3.6 C92.8,71.6,91.4,72.9,89.8,72.9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M34.3,63.4H32c-1.6,0-3,1.3-3,3v3.6c0,1.6,1.3,3,3,3h2.3C34.3,72.9,31.7,68.9,34.3,63.4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M94.9,64.6H26.9c-1.2,0-2.2-1-2.2-2.2v-0.6c0-14.4,11.6-26,26-26h20.5c14.4,0,26,11.6,26,26v0.6 C97.2,63.6,96.2,64.6,94.9,64.6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M29.6,64.6h-2.7c-1.2,0-2.2-1-2.2-2.2v-0.6c0-14.4,11.6-26,26-26C50.7,35.7,28.1,43.2,29.6,64.6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M68.5,39.6c-0.2,0.2-0.8-0.2-1.3-0.8c-0.5-0.6-0.7-1.2-0.5-1.4c0.2-0.2,0.8,0.2,1.3,0.8 C68.5,38.8,68.7,39.4,68.5,39.6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M52.6,39.3c-0.1-0.3,0.3-0.7,1-1.1c0.7-0.4,1.4-0.4,1.5-0.2c0.1,0.3-0.3,0.7-1,1.1 C53.4,39.5,52.8,39.5,52.6,39.3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M61.8,46c-0.3,0-0.5-0.7-0.4-1.4c0.1-0.8,0.3-1.4,0.6-1.4c0.3,0,0.5,0.7,0.4,1.4C62.4,45.4,62.1,46,61.8,46 "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M80,44.3c-0.3,0.1-0.7-0.4-1-1.1c-0.3-0.7-0.3-1.4,0-1.5c0.3-0.1,0.7,0.4,1,1.1 C80.2,43.5,80.3,44.2,80,44.3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M43.6,44.9c-0.3,0.1-0.7-0.4-1-1.1c-0.3-0.7-0.3-1.4,0-1.5c0.3-0.1,0.7,0.4,1,1.1 C43.8,44.1,43.9,44.8,43.6,44.9"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_11_",
    points: "18.5,79.2 42.5,141.3 149,100.2 149,97.4 126,37.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M30.4,109.1c0,0-1-0.6-0.8-1.9c0.2-1.3,0.7-1.3,0.2-2.1c-0.6-0.8-1.2-1.3-0.2-1.9c1-0.6,0.8-1.1,1.1-1.7 c0.3-0.6,0.7-1.3,2.1-1.6c1.4-0.3,10.9-2,30.2-1c19.3,1,39-12.3,43.7-19.4c4.7-7,8-16.5,9.9-18.7c1.9-2.2,2.1-7.5,2-10.2 c-0.1-2.7-0.4-7.5-0.9-8.1c-0.5-0.6-0.5-2,0.6-1.7c1.1,0.3,2.4,1.1,3.2,0.5c0.8-0.6,1.8-0.5,2.4-0.2c0.6,0.3,1.6-0.9,2.2-0.8 c0.5,0,1.2-0.2,0.3,0.9c-0.8,1.1-2,3.2-0.7,8.5c1.3,5.2,2.7,7.7,5.4,12.1c3.9,6.4,4.8,14.1,2.6,21.3c-3,9.8-10.1,18.9-17.7,25.6 c-6.1,5.4-13.2,9.7-21,12.2c-17.2,5.6-31.6,5-37.9,3.5c-6.3-1.5-12.6-3.6-17.4-7c0,0-5.5-4.6-7.2-6.4 C30.9,109.1,30.4,109.1,30.4,109.1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M29.6,107.2c-0.2,1.3,0.8,1.9,0.8,1.9s0.5,0,2.2,1.9c1.7,1.8,7.2,6.4,7.2,6.4c4.8,3.4,11,5.4,17.4,7 c6.3,1.5,20.7,2.2,37.9-3.5c7.8-2.5,14.9-6.8,21-12.2c7.6-6.8,14.7-15.8,17.7-25.6c2.2-7.2,1.3-14.9-2.6-21.3 c-2.7-4.4-4.1-6.9-5.4-12.1c-1.3-5.2-0.1-7.4,0.7-8.5c0.8-1.1,0.2-0.8-0.3-0.9c-0.5,0-1.6,1.1-2.2,0.8c0,0-0.5-0.2-0.9-0.2 c-0.4,0-0.3,0.2-0.3,0.2s0.6,23.4,0.2,27c-0.9,9-5.4,16.8-11.9,23C103,98.9,92.6,105,82,108.4c-10.8,3.5-21.9,3.1-32.9,1.3 c-4.8-0.8-9.2-2-13.8-3.5c-1.6-0.5-2.8-0.9-4-1.4l-2.1-1.1c0,0-0.1,0.3,0.3,0.8c0.4,0.6,0.9,0.7,0.7,1 C29.9,105.8,29.6,107.2,29.6,107.2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M126.5,41.2c1-0.9,0.4-1-0.1-0.9c-0.7,0-1.8,1.2-2.4,0.9c-0.6-0.3-1.6-0.4-2.4,0.2 c-0.8,0.6-2.1-0.2-3.2-0.5c-1.1-0.3-1.3,1.2-0.6,1.7c0,0,1.2,0.5,2.8,0.2c1.6-0.4,2.2-0.8,3-0.7 C124.4,42.2,125.9,41.7,126.5,41.2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M32.8,100c-1.4,0.3-1.9,1-2.1,1.6c-0.3,0.6-0.1,1.1-1.1,1.7c-1.2,0.7,0,1.2,0.1,2.2 c0.1,0.9,0.2,0.4-0.1,1.8c-0.2,1.3,0.8,1.9,0.8,1.9s1-2.8,1.4-4.1C32,103.7,32.8,100,32.8,100"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_85_1_"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 1.5,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 1.5,
    y: 0,
    width: 147.5,
    height: 149.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M142.9,72.8c0,37.4-30.3,67.6-67.6,67.6S7.6,110.2,7.6,72.8S37.9,5.2,75.2,5.2S142.9,35.5,142.9,72.8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M29.8,117H14.8c-3.1,0-5.5-2.5-5.5-5.5c0-3.1,2.5-5.5,5.5-5.5h15.1c3.1,0,5.5,2.5,5.5,5.5 C35.4,114.5,32.9,117,29.8,117"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M42.4,130H23.2c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h19.2c1.9,0,3.5,1.6,3.5,3.5S44.3,130,42.4,130"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M13.7,130H6.2c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h7.5c1.9,0,3.5,1.6,3.5,3.5S15.6,130,13.7,130"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M4.3,98.6c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7C7,97.4,5.8,98.6,4.3,98.6  M4.3,94.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C5.9,95.1,5.2,94.3,4.3,94.3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M118.3,142.5c-2.3,0-4.1-1.9-4.1-4.1c0-2.3,1.9-4.1,4.1-4.1c2.3,0,4.1,1.9,4.1,4.1 C122.4,140.6,120.6,142.5,118.3,142.5 M118.3,135.9c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5 C120.8,137,119.7,135.9,118.3,135.9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M105.5,119.4h21.9c3.1,0,5.5,2.5,5.5,5.5c0,3.1-2.5,5.5-5.5,5.5h-21.9c-3.1,0-5.5-2.5-5.5-5.5 C100,121.9,102.5,119.4,105.5,119.4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M23.1,144.3c3.7-1.6,3.3-1.2,5-5c1.6,3.7,1.2,3.3,5,5c-3.7,1.6-3.3,1.2-5,5C26.5,145.6,26.9,146,23.1,144.3 "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M142.5,102.9c2.4-1,2.1-0.8,3.2-3.2c1,2.4,0.8,2.1,3.2,3.2c-2.4,1-2.1,0.8-3.2,3.2 C144.7,103.7,144.9,103.9,142.5,102.9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M127.1,106.3h7.5c1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.6,3.5-3.5,3.5h-7.5c-1.9,0-3.5-1.6-3.5-3.5 C123.6,107.9,125.2,106.3,127.1,106.3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M147.4,124.9c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5 C144.9,119.4,147.4,121.9,147.4,124.9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "90.5,68.2 61.9,68.2 38.2,119.8 54.8,117.5 74.7,74.2 77.6,74.2 97.6,117.5 114.2,119.8  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "97.6,117.5 77.6,74.2 74.7,74.2 54.8,117.5 63.8,131.6 76.2,104.8 88.5,131.6  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "103.1,96.3 98,95.2 97.1,100.3 92.2,98.4 90.4,103.3 85.9,100.6 83.4,105.2 79.4,101.8 76.2,105.9  72.8,101.9 68.9,105.5 66.2,101 61.8,103.8 59.9,99 55.1,101.1 53.9,96 48.9,97.3 48.5,92.1 43.3,92.6 43.8,87.4 38.6,87.1  40,82 34.9,80.9 37,76.1 32.1,74.1 35,69.7 30.6,67 34.1,63.1 30.1,59.7 34.3,56.5 30.9,52.5 35.5,50 32.8,45.5 37.7,43.7  35.8,38.9 40.9,37.9 39.8,32.8 45,32.7 44.7,27.4 49.9,28.2 50.4,23 55.5,24.5 56.8,19.5 61.5,21.8 63.7,17 67.9,20.1 70.8,15.7  74.5,19.4 78.1,15.6 81.2,19.9 85.3,16.6 87.6,21.3 92.2,18.8 93.8,23.8 98.7,22.1 99.5,27.3 104.6,26.3 104.5,31.6 109.8,31.5  108.8,36.6 114,37.4 112.3,42.3 117.3,43.9 114.7,48.5 119.4,50.8 116.2,55 120.4,58 116.6,61.6 120.3,65.3 115.9,68.2 119,72.5  114.2,74.6 116.5,79.3 111.4,80.7 113,85.7 107.8,86.2 108.5,91.4 103.3,91.1  "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M107.7,60.7c0,17.9-14.5,32.4-32.4,32.4c-17.9,0-32.4-14.5-32.4-32.4c0-17.9,14.5-32.4,32.4-32.4 C93.2,28.4,107.7,42.9,107.7,60.7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M44.9,65c0-19.1,15.5-34.5,34.5-34.5c3.9,0,7.7,0.7,11.2,1.9c-4.6-2.5-9.9-3.9-15.5-3.9 c-17.9,0-32.4,14.5-32.4,32.4c0,5.6,1.4,10.9,3.9,15.5C45.6,72.7,44.9,68.9,44.9,65"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M114.6,51c0-0.1-0.1-0.2-0.1-0.2c-4.1-0.9-7.3-4.1-8.1-8.1c0-0.1-0.1-0.1-0.2-0.1H106 c-0.1,0-0.2,0.1-0.2,0.1c-0.9,4.1-4.1,7.3-8.1,8.1c-0.1,0-0.1,0.1-0.1,0.2v0.1c0,0.1,0.1,0.2,0.1,0.2c4.1,0.9,7.3,4.1,8.1,8.1 c0,0.1,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2-0.1,0.2-0.1c0.9-4.1,4.1-7.3,8.1-8.1c0.1,0,0.1-0.1,0.1-0.2V51z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M61.5,85.3c0-0.1,0-0.1-0.1-0.1c-3.2-0.7-5.7-3.2-6.4-6.4c0-0.1-0.1-0.1-0.1-0.1h-0.1c-0.1,0-0.1,0-0.1,0.1 c-0.7,3.2-3.2,5.7-6.4,6.4c-0.1,0-0.1,0.1-0.1,0.1v0.1c0,0.1,0,0.1,0.1,0.1c3.2,0.7,5.7,3.2,6.4,6.4c0,0.1,0.1,0.1,0.1,0.1h0.1 c0.1,0,0.1,0,0.1-0.1c0.7-3.2,3.2-5.7,6.4-6.4c0.1,0,0.1-0.1,0.1-0.1V85.3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M64.2,44.6C64.2,44.6,64.2,44.6,64.2,44.6c-1.8-0.4-3.2-1.8-3.5-3.5c0,0,0-0.1-0.1-0.1h-0.1c0,0,0,0,0,0 c-0.4,1.8-1.7,3.1-3.5,3.5c0,0-0.1,0-0.1,0.1v0c0,0,0,0.1,0.1,0.1c1.7,0.4,3.1,1.7,3.5,3.5c0,0,0,0.1,0.1,0.1h0.1c0,0,0,0,0,0 c0.4-1.8,1.7-3.1,3.5-3.5C64.2,44.7,64.2,44.7,64.2,44.6L64.2,44.6z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadale);
export default __webpack_public_path__ + "static/media/madale.c68d6215987c02053dfc9ba5e595210a.svg";
export { ForwardRef as ReactComponent };